<script setup>
defineProps({
  sectionTitle: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div
    class="flex items-center w-[680px] sticky z-40 bg-neutral-100 z-30 top-[165px]"
  >
    <div class="flex-grow border-t border-neutral-300" />
    <div
      class="first-letter:capitalize h600 flex items-center justify-center mx-8 bg-neutral-200 rounded-full px-6 py-3 text-black font-semibold shadow-xlg"
    >
      {{ sectionTitle }}
    </div>
    <div class="flex-grow border-t border-neutral-300" />
  </div>
</template>
